import { Pipe, PipeTransform } from '@angular/core';
import { PolishDeclination } from '../services/polish-declination';

@Pipe({name: 'rechargingDeclination'})
export class RechargingDeclination implements PipeTransform {
  transform(_rechargingNumber: number): string {
    const declinations: Array<string> = [
      'doładowanie',
      'doładowania',
      'doładowań'
    ];

    return PolishDeclination(_rechargingNumber, declinations);
  }
}
